import { request } from '~/agent';

export const getPaths = params => {
    return request.get(`paths/tree`, params);
};

export const getPath = (id, params) => {
    return request.get(`paths/${id}/contents`, params);
};

export const createPath = (body, params) => {
    return request.post(`paths`, body, params);
};

export const updatePath = (pathID, body, params) => {
    return request.post(`paths/${pathID}`, body, params);
};

export const deletePath = pathID => {
    return request.del(`paths/${pathID}`);
};

export const updateFileAttachment = (fileAttachmentID, body) => {
    return request.post(`files/attachments/${fileAttachmentID}`, body);
};

export const fileAttachmentMoveMulti = body => {
    return request.post(`files/attachments/move/multi`, body);
};

export const fileAttachmentShareMulti = body => {
    return request.post(`files/attachments/share/multi`, body);
};

export const fileAttachmentShareContacts = params => {
    return request.get(`files/attachments/contacts-for-sharing`, params);
};

export const deleteFileAttachment = fileAttchmentID => {
    return request.del(`files/attachments/${fileAttchmentID}`);
};

export const getFiles = params => {
    return request.get(`files/public`, params);
};

export const addFile = (body, params) => {
    return request.post(`files/public`, body, params);
};

export const getFile = (id, params) => {
    return request.get(`files/public/${id}`, params);
};

export const deleteFile = id => {
    return request.del(`files/public/${id}`);
};

export const downloadFile = (id, params) => {
    return request.get(`files/public/${id}/download`, params);
};

export const downloadMulti = fileIDs => {
    return request.download(`files/download/multi`, null, { fileIDs }, 'POST');
};

export const viewFile = (id, params) => {
    return request.get(`files/public/${id}/preview`, params);
};
/**
 *
 * @param {int} objectID - id of object you are searching files for (example: a contactID from a tenant)
 * @param {int} objectTypeID -id of the type of object (example: the objectTypeID from a tenant)
 * @param {object} params - search parameters in the shape of {search: 'myFile'}
 */
export const searchFiles = (objectID, objectTypeID, params) => {
    return request.get(`files/attachments/${objectTypeID}/${objectID}`, params);
};
